import { Component } from "react";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import PropTypes from "prop-types";

export default class ColumnSelections extends Component {
  constructor(props) {
    super(props);

    this.state = { open: false };
  }

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    const actions = [
      <Button
        key="1"
        variant="outlined"
        color="primary"
        onClick={this.handleClose}
      >
        Close
      </Button>,
    ];

    let { tables, tableKey } = this.props;
    let columns = tables[tableKey].columns;

    return (
      <div className={"table-column-panel "}>
        <div className="table-column-panel-text">
          <Button
            variant="outlined"
            color="secondary"
            onClick={this.handleOpen}
          >
            Hide/Show columns
          </Button>
        </div>
        <Dialog modal={false} open={this.state.open} onClose={this.handleClose}>
          <DialogTitle>Dialog With Actions</DialogTitle>
          <DialogContent>
            {columns.map((col, index) => {
              return (
                <FormControlLabel
                  key={index}
                  style={{ display: "block" }}
                  control={
                    <Checkbox
                      checked={col.visible}
                      onChange={this.props.changeColumnVisibility.bind(
                        this,
                        index,
                        tableKey,
                      )}
                      value="checkedB"
                      color="primary"
                    />
                  }
                  label={col.label}
                />
              );
            })}
          </DialogContent>
          <DialogActions>{actions}</DialogActions>
        </Dialog>
      </div>
    );
  }

  static propTypes = {
    changeColumnVisibility: PropTypes.func,
    tables: PropTypes.object.isRequired,
    tableKey: PropTypes.string.isRequired,
  };
}
